var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-points-index"
  }, [_vm.fetching ? _c('p', [_c('Loading')], 1) : [_c('Notification', {
    ref: "notification",
    staticClass: "s-m-3",
    on: {
      "close": _vm.handleNotificationClosed
    }
  }), _c('Hero', {
    attrs: {
      "title": "紅利點數"
    }
  }, [_c('p', {
    staticClass: "s-font-semibold s-text-3xl s-py-5"
  }, [_vm._v(_vm._s(_vm.$currency(_vm.card.point, '')))]), _c('p', {
    staticClass: "s-text-xs"
  }, [_vm._v("紅利點數將於 24 小時後發放")])]), _c('div', {
    staticClass: "s-bg-white s-mb-8"
  }, [_c('header', {
    staticClass: "s-p-3 s-border-b s-border-gray-light"
  }, [_c('PeriodSelect', {
    attrs: {
      "value": _vm.months
    },
    on: {
      "change": _vm.setMonths
    }
  })], 1), _c('main', {
    staticClass: "s-px-3"
  }, [_vm.points.length ? _c('ul', {
    staticClass: "s-divide-y s-divide-y-gray-light"
  }, _vm._l(_vm.points, function (point, i) {
    return _c('Item', {
      key: i,
      attrs: {
        "point": point
      }
    });
  }), 1) : _c('div', {
    staticClass: "s-py-40 s-text-center"
  }, [_c('img', {
    staticClass: "s-mb-3",
    attrs: {
      "src": require("@/assets/images/liff/empty-coin.svg")
    }
  }), _c('p', {
    staticClass: "s-text-gray"
  }, [_vm._v("沒有點數紀錄")])])])]), _c('Pagination', {
    attrs: {
      "current": _vm.page,
      "last": _vm.lastPage
    }
  })]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }